import { render, staticRenderFns } from "./wxpay_h5.vue?vue&type=template&id=1470079c&scoped=true&"
import script from "./wxpay_h5.vue?vue&type=script&lang=js&"
export * from "./wxpay_h5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470079c",
  null
  
)

export default component.exports